import React, { FC } from 'react';
import { Badge, IconButton, IconButtonSizes, IconButtonStyles, Icons } from '@silverfort/sf-components';
import { SubUserRow } from '../types';
import { useAppDrawer } from '../../../../AppDrawer/AppDrawerProvider';
import InvestigationDrawer from '../../../../InvestigationDrawer/InvestigationDrawer';
import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';

type Props = SubUserRow;

const SubUserNameCell: FC<Props> = ({ id, name }) => {
    const { displayContent } = useAppDrawer();

    const handleInvestigationClick = () => {
        displayContent(<InvestigationDrawer guid={id} adType={AD_ENTITY_TYPES.USER} />);
    };
    return (
        <div className="flex flex-1 flex-row items-center space-between gap-2 overflow-hidden">
            <span className="font-sf leading-[15.51px] shrink truncate">{name.userName}</span>
            {name.isPrimary && <Badge className="font-medium shrink-0" text="Primary user" />}
            <div className="shrink-0 ml-auto">
                <IconButton
                    className="opacity-0 group-hover:opacity-100"
                    sizeVariant={IconButtonSizes.Large}
                    buttonStyle={IconButtonStyles.Secondary}
                    iconSize={20}
                    icon={Icons.Investigate}
                    onClick={handleInvestigationClick}
                />
            </div>
        </div>
    );
};

export default SubUserNameCell;
